import React, { useEffect, useRef, useState } from 'react';
import { Bell, CalendarDays, CircleDot, X } from 'lucide-react';
import useBackLayer from '../hooks/useBackLayer';
import './NotificationWelcome.css';
import { createPortal } from 'react-dom';
const { pushStatus, enableWebPush, pushPreferences, savePushPreferences } = require('../utils/notificationTransport');
const { shouldOfferNotifications, rememberNotificationChoice, hasPlayed } = require('../utils/notificationOnboarding');
export default function NotificationWelcome({ username, played=false }) {
 const [open,setOpen]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState('');
 const [enabled,setEnabled]=useState(false),[daily,setDaily]=useState(true),[wheel,setWheel]=useState(true);
 const prefs=useRef(null),dialog=useRef(null),generation=useRef(0),activeToken=useRef(null);
 useEffect(()=>{
  const version=++generation.current,token=sessionStorage.getItem('reconnectToken'); activeToken.current=token;
  if(hasPlayed(localStorage,username,played)) Promise.all([pushStatus(username,token),pushPreferences(username,token)]).then(([status,preferences])=>{
   if(version!==generation.current||sessionStorage.getItem('reconnectToken')!==token)return;
   prefs.current=preferences;setEnabled(status.enabled);
   if(shouldOfferNotifications(localStorage,username,status,{played,remindersConfigured:preferences.remindersConfigured}))setOpen(true);
  }).catch(()=>{});
  return()=>{generation.current++;};
 },[username,played]);
 useEffect(()=>{if(!open)return;const previous=document.activeElement;dialog.current?.querySelector('button')?.focus();return()=>previous?.focus?.();},[open]);
 const later=()=>{if(busy)return;rememberNotificationChoice(localStorage,username,'later');setOpen(false);};
 useBackLayer(open,later);
 const enable=async()=>{
  const version=generation.current,token=activeToken.current;
  if(sessionStorage.getItem('reconnectToken')!==token)return;
  setBusy(true);setError('');
  // Request OS permission synchronously inside the user's click, before awaiting anything.
  const enabling=enabled?Promise.resolve():enableWebPush(username,token);
  rememberNotificationChoice(localStorage,username,'asked');
  try {
   await enabling;
   if(version!==generation.current||sessionStorage.getItem('reconnectToken')!==token)return;
   const current=await pushPreferences(username,token);
   if(version!==generation.current||sessionStorage.getItem('reconnectToken')!==token)return;
   await savePushPreferences(username,token,Object.assign({},current,{dailyReminder:daily,wheelReminder:wheel,remindersConfigured:true}));
   if(version!==generation.current||sessionStorage.getItem('reconnectToken')!==token)return;
   rememberNotificationChoice(localStorage,username,'enabled');setOpen(false);
  } catch(failure) {if(version===generation.current)setError(failure.message||'Etkinleştirilemedi. Ayarlardan tekrar deneyebilirsin.');}
  finally {if(version===generation.current)setBusy(false);}
 };
 if(!open)return null;
 const trap=event=>{
  if(event.key==='Escape'){later();return;}
  if(event.key!=='Tab')return;
  const items=[...dialog.current.querySelectorAll('button:not(:disabled),input:not(:disabled)')],first=items[0],last=items[items.length-1];
  if(!first){event.preventDefault();return;}
  if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
  else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
 };
 return createPortal(<div className="notification-welcome-backdrop" onKeyDown={trap}>
  <section ref={dialog} tabIndex={-1} role="dialog" aria-modal="true" aria-labelledby="notification-welcome-title" aria-describedby="notification-welcome-copy" className="kelimo-ui kelimo-sheet notification-welcome">
   <button type="button" className="notification-welcome-close" aria-label="Daha sonra" disabled={busy} onClick={later}><X size={22}/></button>
   <div className="notification-welcome-art" aria-hidden="true"><CalendarDays className="notification-art-calendar"/><Bell size={38}/><CircleDot className="notification-art-wheel"/></div>
   <p className="notification-welcome-eyebrow">KELİMO’DA BULUŞALIM</p>
   <h2 id="notification-welcome-title">Bir kelime molasını<br/>kaçırma.</h2>
   <p id="notification-welcome-copy">{enabled?'Bildirimlerin açık. Günlük hatırlatmalarını da sen seç.':'Sıran geldiğinde haberin olsun. Günlük molan için de hatırlatalım.'}</p>
   <div className="notification-welcome-options">
    <label><CalendarDays size={23}/><span><strong>Günün Kelimo’su</strong><small>Henüz başlamadıysan · {prefs.current?.dailyReminderTime||'19:00'}</small></span><input type="checkbox" checked={daily} disabled={busy} onChange={e=>setDaily(e.target.checked)}/></label>
    <label><CircleDot size={23}/><span><strong>Şans Çarkı</strong><small>Hakkın duruyorsa · {prefs.current?.wheelReminderTime||'21:00'}</small></span><input type="checkbox" checked={wheel} disabled={busy} onChange={e=>setWheel(e.target.checked)}/></label>
   </div>
   <p className="notification-welcome-note">Türkiye saati. Saatleri ve bildirimleri Ayarlar’dan değiştirebilirsin.</p>
   {error&&<p role="alert" className="notification-welcome-error">{error}</p>}
   <button type="button" className="notification-welcome-enable" disabled={busy} onClick={enable}>{busy?'Kaydediliyor…':enabled?'Seçimlerimi kaydet':'Bildirimleri aç'}</button>
   <button type="button" className="notification-welcome-later" disabled={busy} onClick={later}>Daha sonra</button>
  </section>
 </div>, window.KELIMO_OVERLAY_HOST || document.body);
}
